/* Selector Boleta/Factura (Fibrolab).
   Persiste la elección y los datos de factura como cart attributes vía
   /cart/update (mismo patrón que cart-note en cart.js) para que sobrevivan
   al re-render del drawer y lleguen al pedido con cualquier método de pago,
   incluidos los botones de checkout dinámico que no pasan por el form. */

if (!customElements.get('cart-doc-type')) {
  customElements.define(
    'cart-doc-type',
    class CartDocType extends HTMLElement {
      connectedCallback() {
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.fieldsWrapper = this.querySelector('.fb-cart-doc__fields');
        this.fields = Array.from(this.querySelectorAll('.fb-cart-doc__fields input'));
        this.rutInput = this.querySelector('[data-doc-field="rut"]');
        this.errorEl = this.querySelector('.fb-cart-doc__error');
        this.form = document.getElementById(this.dataset.form);

        this.radios.forEach((radio) =>
          radio.addEventListener('change', () => {
            this.toggleFields();
            this.persist();
          })
        );

        this.debouncedPersist = debounce(() => this.persist(), ON_CHANGE_DEBOUNCE_TIMER);
        this.fields.forEach((input) => input.addEventListener('input', this.debouncedPersist));

        this.rutInput.addEventListener('blur', () => {
          const value = this.rutInput.value.trim();
          if (value) this.rutInput.value = this.formatRut(value);
        });

        if (this.form) {
          this.onSubmit = (event) => {
            if (!this.isFactura()) return;
            if (!this.validate()) {
              event.preventDefault();
              this.fieldsWrapper.hidden = false;
            }
          };
          this.form.addEventListener('submit', this.onSubmit);
        }

        this.toggleFields();
      }

      disconnectedCallback() {
        if (this.form && this.onSubmit) this.form.removeEventListener('submit', this.onSubmit);
      }

      isFactura() {
        const checked = this.radios.find((radio) => radio.checked);
        return checked && checked.value === 'Factura';
      }

      toggleFields() {
        const factura = this.isFactura();
        this.fieldsWrapper.hidden = !factura;
        this.fields.forEach((input) => (input.required = factura));
        if (!factura) this.hideError();
      }

      persist() {
        const attributes = {
          'Tipo de documento': this.isFactura() ? 'Factura' : 'Boleta',
        };
        this.fields.forEach((input) => {
          // name="attributes[Clave]" -> "Clave"
          attributes[input.name.slice(11, -1)] = input.value.trim();
        });
        const body = JSON.stringify({ attributes });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }

      validate() {
        const empty = this.fields.find((input) => !input.value.trim());
        if (empty) {
          this.showError('Para factura completa todos los datos, o elige boleta.');
          empty.focus();
          return false;
        }
        if (!this.isValidRut(this.rutInput.value)) {
          this.showError('El RUT ingresado no es válido. Revísalo, por favor.');
          this.rutInput.focus();
          return false;
        }
        this.hideError();
        return true;
      }

      showError(message) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      hideError() {
        this.errorEl.hidden = true;
      }

      cleanRut(value) {
        return value.replace(/[^0-9kK]/g, '').toUpperCase();
      }

      isValidRut(value) {
        const clean = this.cleanRut(value);
        if (clean.length < 8) return false;
        const body = clean.slice(0, -1);
        const dv = clean.slice(-1);
        if (!/^\d+$/.test(body)) return false;
        let sum = 0;
        let factor = 2;
        for (let i = body.length - 1; i >= 0; i--) {
          sum += Number(body[i]) * factor;
          factor = factor === 7 ? 2 : factor + 1;
        }
        const rest = 11 - (sum % 11);
        const expected = rest === 11 ? '0' : rest === 10 ? 'K' : String(rest);
        return dv === expected;
      }

      formatRut(value) {
        const clean = this.cleanRut(value);
        if (clean.length < 2) return value;
        const body = clean.slice(0, -1);
        const dv = clean.slice(-1);
        return `${body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${dv}`;
      }
    }
  );
}
